import { createContext, useState, useEffect, useMemo } from "react";
import { User } from "../services/UserService";
import {
  setUserPreferenceLocalStorage,
  getUserAuthLocalStorage,
  getAccessTokenLocalStorage,
  ValidAccessTokenLocalStorage,
  handleUserLogOutErro,
  seti18nextLngLocalStorage,
  setlangStorage,
  handleLanguageFormat,
} from "./utils";
import { HandleAudienceTime } from "../utils/audienceUtils";
import { IUserPreferenceContext } from "../utils/types";



export const UserPreferenceContext = createContext({} as IUserPreferenceContext);
const UserPreferenceProvider = ({ children }) => {
  useEffect(() => { }, []);

  const [userAuthenticated, setUserAuthenticated] = useState<boolean>(false);
  const [userPreference, setUserPreference] = useState<any>();
  const [horaIniCalendar, setHoraIniCalendar] = useState<string>();
  const [horaFinCalendar, setHoraFinCalendar] = useState<string>();
  const [userMenssageApi, setUserMenssageApi] = useState<string>();
  const [loaded, setLoaded] = useState<boolean>(false);
  const [minuteImage, setMinuteImage] = useState<number>(0);
  const [userTarget, setUserTarget] = useState<any>(null);

  function updateUserPreference(userData) {
    if (
      userData?.data !== null &&
      userData?.data !== undefined &&
      Number(userData?.data?.CodigoRetorno === 0) &&
      Number(userData?.data?.UserId > 0)
    ) {
      setUserPreference(userData.data);
      HandleAudienceTime(userData.data, setHoraIniCalendar, setHoraFinCalendar);
    }
  }

  function handleResponseDataUserPreference(res, userAuth) {
    if (
      res?.data !== undefined &&
      res?.data !== null &&
      Number(res?.data?.UserId > 0) &&
      userAuth?.username !== undefined
    ) {

      setUserPreference(res.data);

      setUserPreferenceLocalStorage(res.data, userAuth);
      seti18nextLngLocalStorage(
        handleLanguageFormat(res?.data?.Language?.IdiomaPrefixo)
      );
      setlangStorage(handleLanguageFormat(res?.data?.Language?.IdiomaPrefixo));
      if (!userAuthenticated) {
        setUserAuthenticated(true);
        setLoaded(true);
      }
      HandleAudienceTime(res.data, setHoraIniCalendar, setHoraFinCalendar);
    }
  }

  async function doUserPreference() {
    let token = getAccessTokenLocalStorage();
    let userAuth = getUserAuthLocalStorage();
    if (ValidAccessTokenLocalStorage()) {

      await User(token)
        .then(async (res) => {
          setUserPreference(res.data);
          handleResponseDataUserPreference(res, userAuth);
        })
        .catch((err) => {
          handleReturnWithWError401(
            err,
            userAuthenticated,
            setUserAuthenticated, setUserMenssageApi
          );
        });
    }
  }

  async function userPost(userPreference: any) {
    if (ValidAccessTokenLocalStorage()) {
      setUserTarget(userPreference);
    }
  }

  const objMemoProvider = useMemo<IUserPreferenceContext>(
    () => ({
      userPreference,
      doUserPreference,
      userPost,
      userTarget,
      updateUserPreference,
      userAuthenticated,
      setUserAuthenticated,
      horaIniCalendar,
      horaFinCalendar,
      setHoraIniCalendar,
      setHoraFinCalendar,
      userMenssageApi, setUserMenssageApi,
      loaded, setLoaded,
      minuteImage, setMinuteImage,
      setUserPreference, setUserTarget
    }),
    [userPreference, userAuthenticated, horaIniCalendar, horaFinCalendar, userMenssageApi, loaded, minuteImage, userTarget]
  );
  return (
    <UserPreferenceContext.Provider value={objMemoProvider}>
      {children}
    </UserPreferenceContext.Provider>
  );
};

export default UserPreferenceProvider;
function handleReturnWithWError401(
  resultError,
  userAuthenticated,
  setUserAuthenticated, setUserMenssageApi
) {
  handleUserLogOutErro(resultError, userAuthenticated, setUserAuthenticated, setUserMenssageApi);
}
